import a, { useCallback as d, useMemo as C } from "react";
import { Swatch as x } from "../swatch/swatch.esm.js";
import { TypographyComponent as f } from "../typography/typography-component.esm.js";
import { ScreenReaderOnly as y } from "../utils/sr-only.esm.js";
import { visibleSwatchesCount as t } from "./config.esm.js";
const g = "_productCard__swatchContainer_1wxmb_1", S = "_productCard__swatchCount_1wxmb_8", k = "_productCard__swatch_1wxmb_1", l = {
  productCard__swatchContainer: g,
  productCard__swatchCount: S,
  productCard__swatch: k
}, $ = { xxs: "small", m: "medium", l: "large" }, b = { xxs: "m2", m: "m1", l: "1" }, _ = Object.keys(t);
function E({ swatches: o = [] }) {
  const m = d(
    (r) => r > 1 ? "colours" : "colour",
    []
  ), c = d(
    (r) => {
      const e = o.length - t[r].min;
      return `Available in ${o.map(
        (n, s) => s < t[r].min ? n == null ? void 0 : n.displayName : null
      ).filter(Boolean).join(", ")} and ${e} more colours`;
    },
    [o]
  ), p = d(
    (r) => {
      if (!(o.length > t[r].max)) {
        const u = o.map((n) => n == null ? void 0 : n.displayName);
        return `Available in ${u.join(", ")} ${m(u.length)}`;
      }
      return c(r);
    },
    [c, m, o]
  ), i = C(() => o != null && o.length ? [
    { key: "xxs", from: 0, to: t.xxs.min },
    { key: "xs", from: t.xxs.min, to: t.xs.min },
    { key: "m", from: t.xs.min, to: t.m.min },
    { key: "l", from: t.m.min, to: t.l.min },
    { key: "xxl", from: t.l.min, to: t.xxl.min }
  ].flatMap(({ key: r, from: e, to: u }) => o.slice(e, u).map((n) => ({ ...n, size: r }))) : [], [o]);
  return i.length ? /* @__PURE__ */ a.createElement(
    "div",
    {
      className: l.productCard__swatchContainer,
      "data-testid": "fuse-product-card__colour-swatch"
    },
    i.map((r, e) => /* @__PURE__ */ a.createElement(
      x,
      {
        key: (r == null ? void 0 : r.displayName) || e,
        className: `${l.productCard__swatch} fuse-product-card__colour-swatch`,
        size: $,
        "aria-label": r == null ? void 0 : r.displayName,
        imageSrc: (r == null ? void 0 : r.imageSrc) && `${r.imageSrc}?$20x20_standard$`,
        "data-screen": r == null ? void 0 : r.size,
        "data-testid": "fuse-product-card__colour-swatch-item"
      }
    )),
    /* @__PURE__ */ a.createElement(
      f,
      {
        type: "paragraph",
        "aria-hidden": !0,
        size: b,
        "data-testid": "fuse-product-card__colour-swatch-count"
      },
      _.map((r) => {
        const e = o.length - t[r].min;
        return e <= 0 ? null : /* @__PURE__ */ a.createElement(
          "span",
          {
            key: r,
            className: l.productCard__swatchCount,
            "data-screen": r,
            "data-testid": `fuse-product-card__colour-swatch-count--${r}`
          },
          "+",
          e,
          " ",
          m(e)
        );
      })
    ),
    _.map((r) => /* @__PURE__ */ a.createElement(
      "span",
      {
        key: r,
        className: l.productCard__swatchCount,
        "data-screen": r,
        "data-testid": `fuse-product-card__colour-swatch-count--${r}`
      },
      /* @__PURE__ */ a.createElement(y, null, p(r))
    ))
  ) : null;
}
E.displayName = "ColourSwatch";
export {
  E as ColourSwatch
};
